import { RuleObject, StoreValue } from 'rc-field-form/es/interface';
import { dateWorker } from '@core/utils/date-worker';
import { RangePickerValues } from '@models/interfaces';

export const rangeOrderValidator = (
  type: keyof RangePickerValues,
  value?: RangePickerValues,
): RuleObject => ({
  validator: (_: RuleObject, candidate: StoreValue) => {
    const from = type === 'from' ? candidate : value?.from;
    const to = type === 'to' ? candidate : value?.to;

    return from && to && dateWorker(to).isBefore(from)
      ? Promise.reject(new Error('Start Date must be before End Date!'))
      : Promise.resolve();
  },
});
